const createNotificationContainer = () => {
  let container = document.getElementById('es-notifications');
  if (!container) {
    container = document.createElement('div');
    container.id = 'es-notifications';
    container.className = 'es-notification-container';
    document.body.appendChild(container);
  }
  return container;
};

export const notification = {
  success: ({ message, description }) => {
    const container = createNotificationContainer();
    const el = document.createElement('div');
    el.className = 'es-notification es-notification-success';
    el.innerHTML = `<div style="font-weight:600">${message}</div>${description ? `<div style="font-size:12px;margin-top:4px;opacity:0.9">${description}</div>` : ''}`;
    container.appendChild(el);
    setTimeout(() => { el.style.opacity = '0'; el.style.transition = 'opacity 0.3s'; setTimeout(() => el.remove(), 300); }, 3000);
  },
  error: ({ message, description }) => {
    const container = createNotificationContainer();
    const el = document.createElement('div');
    el.className = 'es-notification es-notification-error';
    el.innerHTML = `<div style="font-weight:600">${message}</div>${description ? `<div style="font-size:12px;margin-top:4px;opacity:0.9">${description}</div>` : ''}`;
    container.appendChild(el);
    setTimeout(() => { el.style.opacity = '0'; el.style.transition = 'opacity 0.3s'; setTimeout(() => el.remove(), 300); }, 3000);
  },
  warning: ({ message, description }) => {
    const container = createNotificationContainer();
    const el = document.createElement('div');
    el.className = 'es-notification es-notification-warning';
    el.innerHTML = `<div style="font-weight:600">${message}</div>${description ? `<div style="font-size:12px;margin-top:4px;opacity:0.9">${description}</div>` : ''}`;
    container.appendChild(el);
    setTimeout(() => { el.style.opacity = '0'; el.style.transition = 'opacity 0.3s'; setTimeout(() => el.remove(), 300); }, 3000);
  },
  info: ({ message, description }) => {
    const container = createNotificationContainer();
    const el = document.createElement('div');
    el.className = 'es-notification es-notification-info';
    el.innerHTML = `<div style="font-weight:600">${message}</div>${description ? `<div style="font-size:12px;margin-top:4px;opacity:0.9">${description}</div>` : ''}`;
    container.appendChild(el);
    setTimeout(() => { el.style.opacity = '0'; el.style.transition = 'opacity 0.3s'; setTimeout(() => el.remove(), 300); }, 3000);
  },
};
